<div class="modal-header border-0 text-center">
  <div class="w-100">
    <fa-icon [icon]="faCheckCircle" class="text-success" size="3x"></fa-icon>
    <h4 class="modal-title mt-3 text-success">Payment Successful!</h4>
  </div>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body text-center">
  <div class="payment-details">
    <div class="row mb-3">
      <div class="col-12">
        <h5 class="mb-0">Amount Paid</h5>
        <h2 class="text-primary font-weight-bold">${{ paymentAmount }}</h2>
      </div>
    </div>

    <div class="card payment-summary">
      <div class="card-body">
        <h6 class="card-title text-left">Transaction Details</h6>

        <div class="detail-row">
          <span class="detail-label">Transaction ID:</span>
          <span class="detail-value font-weight-bold">{{ paymentResult.transactionId }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Payment Method:</span>
          <span class="detail-value">{{ maskedCardNumber }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Date:</span>
          <span class="detail-value">{{ currentDate }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Time:</span>
          <span class="detail-value">{{ currentTime }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Status:</span>
          <span class="detail-value">
            <span class="badge badge-success">{{ paymentResult.status | titlecase }}</span>
          </span>
        </div>
      </div>
    </div>

    <div class="alert alert-info mt-3" *ngIf="paymentResult.message">
      {{ paymentResult.message }}
    </div>

    <div class="action-buttons mt-4">
      <button type="button" class="btn btn-outline-primary mr-2" (click)="printReceipt()">
        <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>
        Print Receipt
      </button>

      <button type="button"
              class="btn btn-outline-primary mr-2"
              (click)="downloadReceipt()"
              *ngIf="paymentResult.receiptUrl">
        <fa-icon [icon]="faDownload" class="mr-1"></fa-icon>
        Download Receipt
      </button>
    </div>

    <div class="confirmation-note mt-4">
      <small class="text-muted">
        A confirmation email will be sent to your registered email address.
        Please keep this transaction ID for your records.
      </small>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-center border-0">
  <button type="button" class="btn btn-primary btn-lg" (click)="close()">
    Continue
  </button>
</div>